 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Accesibility":"Accesibility","privacyPolicy":"privacyPolicy","vr":"vr","dashboard":"dashboard","graph":"graph","firstView":"firstView","notFound":"notFound","settings":"settings","termsOfUse":"termsOfUse","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"Accesibility":"18ceb5ce","chunk-029cc271":"1df4ebf4","chunk-03f700a8":"8fb4e845","chunk-09ef112e":"0b511825","chunk-0eb093d4":"3aed0c76","chunk-0ebc9918":"412cb627","chunk-10629814":"f1eb42e2","chunk-12a9aba4":"21f558d7","chunk-19083a5c":"21183989","chunk-1e31ad7b":"ab6090ce","chunk-217f9372":"a127d6fc","chunk-23ee410f":"5d87bb41","chunk-28b2beed":"4cfb9034","chunk-2d0e4e43":"9507ee53","chunk-2de09c48":"12bf422d","chunk-31f167d3":"e48d28de","chunk-389b814a":"8bbda979","chunk-4b8400e9":"9c7d996f","chunk-541bbfdd":"52a71070","chunk-57ce8419":"74b480b7","chunk-2d0e88eb":"22caf40d","chunk-5b0829f8":"2e8ca536","chunk-5c73de0c":"38c56437","chunk-5c76b18c":"cb76f200","chunk-2f51243d":"ed3d1e43","chunk-bcf75448":"d2af0c98","chunk-133c133f":"043b9336","chunk-725b7780":"d0943a34","chunk-74fc03cf":"62711603","chunk-7b0ef66b":"48a38d53","chunk-88a7ab00":"b8a0bfa4","chunk-896ed144":"243752be","chunk-a396c550":"e586e1ad","chunk-3b86f888":"be528b36","chunk-4c26643d":"ec7476e1","chunk-a49eb7d0":"17b70f16","chunk-b9a626c2":"eadce7b5","chunk-bcd00c5e":"f0773fb6","chunk-d28ca866":"76bdf514","chunk-a558f4c4":"ed83bf06","privacyPolicy":"4e8bc995","chunk-dd24daa2":"f38465e5","chunk-323dd878":"7536974a","chunk-03e7d253":"fa009b3a","chunk-074b8733":"2fd8a574","chunk-619daa58":"63696060","vr":"fcb43aaf","chunk-54a231fe":"6e5361fd","chunk-0be5042c":"5f4f4e1e","chunk-467159be":"3c45c260","chunk-ee7103d2":"f91cc151","chunk-5cac6dd4":"e7dc49f1","dashboard":"8818efc6","chunk-8f0a6ac2":"5b88e4a7","chunk-5fc8ceac":"d92d9a9d","chunk-674ea17e":"9dcdcc9a","chunk-a9346350":"27114f0e","graph":"c90c2849","chunk-e027a6b0":"ee3cc400","chunk-efda49e6":"b9f4f270","firstView":"ea0dfc1f","notFound":"f780047c","settings":"a46945a9","termsOfUse":"99868887","canvg":"f4b190a5","pdfmake":"35db232b","xlsx":"6f74902a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Accesibility":1,"chunk-029cc271":1,"chunk-03f700a8":1,"chunk-09ef112e":1,"chunk-0eb093d4":1,"chunk-0ebc9918":1,"chunk-10629814":1,"chunk-12a9aba4":1,"chunk-19083a5c":1,"chunk-1e31ad7b":1,"chunk-217f9372":1,"chunk-28b2beed":1,"chunk-2de09c48":1,"chunk-31f167d3":1,"chunk-389b814a":1,"chunk-4b8400e9":1,"chunk-5b0829f8":1,"chunk-5c73de0c":1,"chunk-bcf75448":1,"chunk-133c133f":1,"chunk-725b7780":1,"chunk-74fc03cf":1,"chunk-7b0ef66b":1,"chunk-88a7ab00":1,"chunk-896ed144":1,"chunk-3b86f888":1,"chunk-4c26643d":1,"chunk-a49eb7d0":1,"chunk-b9a626c2":1,"chunk-bcd00c5e":1,"chunk-d28ca866":1,"chunk-a558f4c4":1,"privacyPolicy":1,"chunk-074b8733":1,"chunk-619daa58":1,"vr":1,"chunk-0be5042c":1,"chunk-467159be":1,"chunk-ee7103d2":1,"dashboard":1,"chunk-8f0a6ac2":1,"chunk-5fc8ceac":1,"chunk-674ea17e":1,"chunk-a9346350":1,"graph":1,"chunk-e027a6b0":1,"firstView":1,"settings":1,"termsOfUse":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Accesibility":"Accesibility","privacyPolicy":"privacyPolicy","vr":"vr","dashboard":"dashboard","graph":"graph","firstView":"firstView","notFound":"notFound","settings":"settings","termsOfUse":"termsOfUse","canvg":"canvg","pdfmake":"pdfmake","xlsx":"xlsx"}[chunkId]||chunkId) + "." + {"Accesibility":"b6e9922f","chunk-029cc271":"e77f6c81","chunk-03f700a8":"560bf4e8","chunk-09ef112e":"2acdd232","chunk-0eb093d4":"630fd0c9","chunk-0ebc9918":"3581161b","chunk-10629814":"e809a5fe","chunk-12a9aba4":"44d0cd9f","chunk-19083a5c":"81c26af9","chunk-1e31ad7b":"d652e829","chunk-217f9372":"f3424dfa","chunk-23ee410f":"31d6cfe0","chunk-28b2beed":"893d7a17","chunk-2d0e4e43":"31d6cfe0","chunk-2de09c48":"5761e25f","chunk-31f167d3":"c50c628c","chunk-389b814a":"e37db1b8","chunk-4b8400e9":"e933072d","chunk-541bbfdd":"31d6cfe0","chunk-57ce8419":"31d6cfe0","chunk-2d0e88eb":"31d6cfe0","chunk-5b0829f8":"627acdd3","chunk-5c73de0c":"a733ac73","chunk-5c76b18c":"31d6cfe0","chunk-2f51243d":"31d6cfe0","chunk-bcf75448":"31d86822","chunk-133c133f":"59314ee7","chunk-725b7780":"1f98d799","chunk-74fc03cf":"46ca0546","chunk-7b0ef66b":"8c3f18d3","chunk-88a7ab00":"94f0a501","chunk-896ed144":"5f94e5b1","chunk-a396c550":"31d6cfe0","chunk-3b86f888":"954ff9d3","chunk-4c26643d":"15499b7b","chunk-a49eb7d0":"7e038114","chunk-b9a626c2":"0e433876","chunk-bcd00c5e":"d5f16987","chunk-d28ca866":"d925837f","chunk-a558f4c4":"980bb60f","privacyPolicy":"180f0050","chunk-dd24daa2":"31d6cfe0","chunk-323dd878":"31d6cfe0","chunk-03e7d253":"31d6cfe0","chunk-074b8733":"ab35330e","chunk-619daa58":"52c9b5f3","vr":"9eee3df8","chunk-54a231fe":"31d6cfe0","chunk-0be5042c":"436e36c3","chunk-467159be":"b8415fb7","chunk-ee7103d2":"5f27f9ef","chunk-5cac6dd4":"31d6cfe0","dashboard":"662df0a8","chunk-8f0a6ac2":"4cb4c37e","chunk-5fc8ceac":"a0abe2f5","chunk-674ea17e":"b0004170","chunk-a9346350":"1ada23da","graph":"43c4baa5","chunk-e027a6b0":"4eeb60bb","chunk-efda49e6":"31d6cfe0","firstView":"7c0f117f","notFound":"31d6cfe0","settings":"57ecf580","termsOfUse":"e9fa1b07","canvg":"31d6cfe0","pdfmake":"31d6cfe0","xlsx":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
